import styled from 'styled-components';

export const Container = styled.div`
  padding: 24px;
  
  @media (max-width: 1024px) {
    padding: 16px;
  }
  
  @media (max-width: 768px) {
    padding: 12px;
  }
  
  @media (max-width: 480px) {
    padding: 8px;
  }
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  gap: 16px;
  
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
    margin-bottom: 16px;
  }
`;

export const Title = styled.h1`
  color: ${props => props.theme.text};
  margin: 0;
  font-size: 28px;
  
  @media (max-width: 1024px) {
    font-size: 24px;
  }
  
  @media (max-width: 768px) {
    font-size: 22px;
    text-align: center;
  }
  
  @media (max-width: 480px) {
    font-size: 20px;
  }
`;

export const AddButton = styled.button`
  width: 205px;
  height: 45px;
  background-color: ${({ theme }) => theme.primary};
  color: ${({ theme }) => theme.primaryOn};
  border-radius: 10px;
  border: none;
  padding: 8px 16px;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background-color: ${({ theme }) => theme.primary};
  }
  
  @media (max-width: 768px) {
    width: 100%;
    height: 48px;
    font-size: 16px;
  }
  
  @media (max-width: 480px) {
    height: 44px;
    font-size: 14px;
  }
`;

export const RuleList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const RuleItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: ${props => props.theme.usersDivBackground};
  padding: 16px;
  border-radius: 10px;
  color: ${props => props.theme.text};
  font-size: 16px;
  font-weight: 500;
  min-height: 80px;
  gap: 16px;
  
  @media (max-width: 1024px) {
    padding: 14px;
    font-size: 15px;
    gap: 12px;
  }
  
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
    padding: 16px;
    gap: 12px;
    min-height: auto;
  }
  
  @media (max-width: 480px) {
    padding: 12px;
    font-size: 14px;
    gap: 8px;
  }
`;

export const ActionButtons = styled.div`
  display: flex;
  gap: 8px;
  
  @media (max-width: 768px) {
    justify-content: center;
    width: 100%;
    gap: 12px;
    border-top: 1px solid ${props => props.theme.border || 'rgba(255,255,255,0.1)'};
    padding-top: 12px;
    margin-top: 8px;
  }
`;

export const IconButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.primaryOn};
  transition: opacity 0.2s;

  .icon {
    width: 20px;
    height: 20px;
  }

  &:hover {
    opacity: 0.8;
  }
  
  @media (max-width: 768px) {
    padding: 8px;
    min-width: 44px;
    min-height: 44px;
    border-radius: 8px;
    
    .icon {
      width: 22px;
      height: 22px;
    }
  }
  
  @media (max-width: 480px) {
    padding: 6px;
    min-width: 40px;
    min-height: 40px;
    
    .icon {
      width: 20px;
      height: 20px;
    }
  }
`;

export const EditButton = styled(IconButton)`
  color: ${({ theme }) => theme.primaryAccent};
`;

export const DeleteButton = styled(IconButton)`
  color: ${({ theme }) => theme.error};
`;

export const DeleteModal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

export const DeleteModalContent = styled.div`
  background-color: ${({theme}) => theme.deleteModalBackground};
  border-radius: 8px;
  border: 1px solid ${({theme}) => theme.deleteModalBorder};
  padding: 24px;
  width: 400px;
  max-width: 90%;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  
  h3 {
    color: ${({theme}) => theme.error};
    margin-bottom: 16px;
  }
  
  p {
    margin-bottom: 24px;
    line-height: 1.5;
  }
  
  @media (max-width: 768px) {
    width: 90vw;
    padding: 20px;
    border-radius: 12px;
    
    h3 {
      font-size: 18px;
      margin-bottom: 12px;
    }
    
    p {
      font-size: 14px;
      margin-bottom: 20px;
    }
  }
  
  @media (max-width: 480px) {
    width: 95vw;
    padding: 16px;
    max-height: 90vh;
    
    h3 {
      font-size: 16px;
    }
    
    p {
      font-size: 13px;
    }
  }
`;

export const DeleteModalButtons = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  
  @media (max-width: 768px) {
    flex-direction: column-reverse;
    gap: 8px;
  }
  
  @media (max-width: 480px) {
    margin-top: auto;
  }
`;

export const CancelButton = styled.button`
  padding: 8px 16px;
  border-radius: 4px;
  border: 1px solid ${({theme}) => theme.border};
  background-color: ${({theme}) => theme.backgroundCancelButtonDeleteModal};
  color: ${({theme}) => theme.text};
  cursor: pointer;
  transition: all 0.2s;
  
  &:hover {
    background-color: ${({theme}) => theme.hoverCancelButtonDeleteModal};
  }
  
  @media (max-width: 768px) {
    padding: 12px 20px;
    font-size: 16px;
    min-height: 48px;
    width: 100%;
  }
  
  @media (max-width: 480px) {
    padding: 10px 16px;
    font-size: 14px;
    min-height: 44px;
  }
`;

export const ConfirmButton = styled.button`
  padding: 8px 16px;
  border-radius: 4px;
  border: none;
  background-color: ${({theme}) => theme.backgroundConfirmButtonDeleteModal};
  color: ${({ theme }) => theme.errorOn};
  cursor: pointer;
  transition: all 0.2s;
  
  &:hover {
    background-color: ${({theme}) => theme.hoverConfirmButtonDeleteModal};
  }
  
  @media (max-width: 768px) {
    padding: 12px 20px;
    font-size: 16px;
    min-height: 48px;
    width: 100%;
  }
  
  @media (max-width: 480px) {
    padding: 10px 16px;
    font-size: 14px;
    min-height: 44px;
  }
`;

// Novos componentes para estrutura responsiva das regras
export const RuleInfo = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
  gap: 4px;
  
  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const RuleInfoItem = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
  
  @media (max-width: 768px) {
    flex-direction: row;
    align-items: center;
    gap: 8px;
  }
`;

export const RuleInfoLabel = styled.span`
  font-size: 12px;
  color: ${props => props.theme.textSecondary || props.theme.placeholderColor};
  font-weight: 400;
  margin-bottom: 2px;
  display: none;
  
  @media (max-width: 768px) {
    display: block;
    min-width: 60px;
    font-weight: 500;
  }
`;

export const RuleInfoValue = styled.span`
  font-weight: 500;
  color: ${props => props.theme.text};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  
  @media (max-width: 768px) {
    white-space: normal;
    word-break: break-word;
  }
`; 